import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence, connectAuthEmulator } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: 'AIzaSyDiKa92n0KUzXMhX-2tDTj7kLFO5n9dHds',
    authDomain: 'ga-db-access.firebaseapp.com',
    projectId: 'ga-db-access',
    storageBucket: 'ga-db-access.appspot.com',
    messagingSenderId: '183444359322',
    appId: '1:183444359322:web:13b5e3bd6244022182f723',
    measurementId: 'G-5XXZBEYQJF',
};

const firebaseEmulatorConfig = {
    apiKey: 'AIzaSyDiKa92n0KUzXMhX-2tDTj7kLFO5n9dHds',
    authDomain: process.env.VUE_APP_EMULATOR_HOST,
    projectId: 'ga-db-access',
    storageBucket: process.env.VUE_APP_EMULATOR_HOST,
    messagingSenderId: 'localhost',
    appId: '1:183444359322:web:13b5e3bd6244022182f723',
    measurementId: 'G-5XXZBEYQJF',
};

const listEnforceFirebaseConfig = {
    apiKey: 'AIzaSyD427qmK0oChzpJ6ZDSyE3IaJEPCUwe0-8',
    authDomain: 'ga-list-enforcement.firebaseapp.com',
    projectId: 'ga-list-enforcement',
    storageBucket: 'ga-list-enforcement.appspot.com',
    messagingSenderId: '332423252847',
    appId: '1:332423252847:web:636d0b3c021a93a06cb69a',
    measurementId: 'G-N7T6FGN5CE',
};

export function modeIsEmulator() {
    return process.env.NODE_ENV === 'development' && process.env.VUE_APP_FIREBASE_MODE === 'development';
}

// Initialize Firebase
const fireapp = modeIsEmulator() ? initializeApp(firebaseEmulatorConfig) : initializeApp(firebaseConfig);
const fireauth = getAuth(fireapp);
const fireanalytics = getAnalytics(fireapp);
const firedb = getFirestore(fireapp);
const storage = getStorage(fireapp);

// Connect to Emulators if in development mode
if (modeIsEmulator()) {
    const hostname = process.env.VUE_APP_EMULATOR_HOST;
    const authSocket = 'http://' + hostname + ':' + process.env.VUE_APP_AUTH_PORT;
    console.log('Connecting to Auth Emulator at:', authSocket);
    connectAuthEmulator(fireauth, authSocket);

    const firestoreSocket = 'http://' + hostname + ':' + process.env.VUE_APP_FIRESTORE_PORT;
    console.log('Connecting to Firestore Emulator at:', firestoreSocket);
    connectFirestoreEmulator(firedb, hostname, process.env.VUE_APP_FIRESTORE_PORT);
}

// Initialize list enforcement firebase config
const fireapp_listEnforce = initializeApp(listEnforceFirebaseConfig, 'secondary');
const fireauth_listEnforce = getAuth(fireapp_listEnforce);
const fireanalytics_listEnforce = getAnalytics(fireapp_listEnforce);
const firedb_listEnforce = getFirestore(fireapp_listEnforce);

setPersistence(fireauth, browserLocalPersistence);

export { fireauth, fireanalytics, firedb, storage, fireapp };
export { fireauth_listEnforce, fireanalytics_listEnforce, firedb_listEnforce };
